import _ from 'lodash'
import {
    justifyButton,
    validateButton,
    saveButton,
    returnButton,
    submitButton,
    acceptButton,
    refuseButton,
    examineButton,
    transmitPaymentsButton,
    closePaymentsButton,
    updateDocumentsButton, updateButton, sendMessageButton
} from '../utils'
import path from "path";
import {basicContext} from "../../../utils/contextUtils";

export const getButtonsForModule = async (applicationOrPayment, context) => {
    const statusId = _.get(applicationOrPayment, 'status.id');
    const { moduleId } = context.clientContext;
    let buttons = []

    switch (moduleId) {
        case 'm-C-submission':
            if (statusId === 'draft') {
                buttons = [submitButton, saveButton, returnButton]
            }
            if(statusId === 'questioned') {
                return [updateButton, saveButton, returnButton]
            }
            break
        case 'm-C-study':
            if (['ongoing', 'updated'].includes(statusId)) {
                buttons = [
                    {
                        ...acceptButton,
                        tKey: 'TRANSMETTRE POUR DÉCISION',
                    },
                    examineButton,
                    returnButton
                ]
            }
            break
        case 'm-C-decision':
            if (statusId === 'controlled') {
                buttons = [acceptButton, refuseButton, examineButton, returnButton]
            }
            break
        case 'm-C-reliefFundPayment':
            if (statusId === 'accepted') {
                buttons = [transmitPaymentsButton, sendMessageButton, closePaymentsButton, saveButton, returnButton]
            }
            break
        case 'm-C-reliefFundPaymentValidation':
            if(statusId === 'ongoing') {
                buttons = [validateButton, refuseButton, justifyButton, returnButton]
            }
            break
        case 'm-C-followUp':
            if( !['closed', 'refused'].includes(statusId) ) {
                const cUser = await global.app.C.CUser.get({kpUser: new global.ObjectID(context.user.id)}, {
                    ...basicContext(context),
                    fieldPath: [
                        'id',
                        'functions.id',
                        'functions.submissionAuthorization',
                        'functions.studyAuthorization',
                        'functions.decisionAuthorization',
                        'functions.solicitationsManagementAuthorization',
                        'functions.liberationAuthorization',
                        'organization.id',
                        'organization.hasShelters'
                    ]
                })
                const userIsAdmin = ['studyAuthorization', 'decisionAuthorization', 'solicitationsManagementAuthorization', 'liberationAuthorization'].some(
                    key => cUser.functions.some(
                        userFunction => !!userFunction[key]
                    )
                )

                const userId = _.get(context, 'user.id')
                const submitterId = _.get(applicationOrPayment, 'submitter.id')
                const userIsSubmitter = userId && submitterId && new global.ObjectID(userId).toString() === new global.ObjectID(submitterId).toString()

                if (userIsAdmin){
                    buttons.push(sendMessageButton)
                }
                if (userIsSubmitter) {
                    buttons.push(updateDocumentsButton)
                }
            }
    }

    // Adding a return button if not already included, to always allow going back
    if (!buttons.includes(returnButton)) {
        buttons.push(returnButton)
    }

    return buttons
}


export function prepareDefaultMail() {

    return {
        from: `"CNDA - Fonds de Secours Exceptionnel"secours@defensedelanimal.fr`,
        replyTo: "secours@defensedelanimal.fr",
        templateDir: path.join(global.appRoot, global.isProd ? 'buildServer' : 'src' , '/server/models/cnda/templates'),
        verbose: {
            general: true,
        }
    }
}

export async function getUsersWithAuthorization(authorization) {
    return await global.app.C.CUser.collection
        .aggregate([
            { $lookup: {
                    from: 'c.function',
                    let: { 'functionIds': { $ifNull: ['$functions', []] } },
                    pipeline: [
                        {
                            $match: {
                                [authorization]: true,
                                '$expr': { '$in': ['$_id', '$$functionIds'] }
                            }
                        },
                    ],
                    as:'functions'
                }
            },
            {
                $match: {
                    $expr: { $gt: [{ $size: '$functions' }, 0] }
                }
            }
        ]).toArray()
}
